import { createRouter, createWebHistory } from 'vue-router'
import api from '../services/api'

const routes = [
  {
    path: '/',
    redirect: '/historias'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/historias',
    name: 'Historias',
    component: () => import('../components/HistoriasList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/historias/:id',
    name: 'HistoriaDetalle',
    component: () => import('../components/HistoriaDetalle.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/historias/:historiaId/tramas/:tramaId',
    name: 'TramaDetalle',
    component: () => import('../components/TramaDetalle.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/metodos',
    name: 'Metodos',
    component: () => import('../components/MetodosList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/metodos/:id',
    name: 'MetodoDetalle',
    component: () => import('../components/MetodoDetalle.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/datos',
    name: 'DatosJuego',
    component: () => import('../components/DatosJuego.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bot-vinculos',
    name: 'BotVinculos',
    component: () => import('../components/BotVinculosEditor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/escenarios',
    name: 'Escenarios',
    component: () => import('../components/EscenariosList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/escenarios/:escenarioId',
    name: 'EscenarioEditor',
    component: () => import('../components/EscenarioEditor.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/escenarios/:escenarioId/metodos/:metodoId',
    name: 'MetodoEscenarioDetalle',
    component: () => import('../components/MetodoEscenarioDetalle.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/casos',
    name: 'Casos',
    component: () => import('../views/Casos.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/app/partidas',
    name: 'EnvivoPartidas',
    component: () => import('../views/EnvivoPartidas.vue'),
    meta: { requiresAuth: true }
  },
    {
    path: '/dev/partidas',
    name: 'EnvivoDevPartidas',
    component: () => import('../views/EnvivoDevPartidas.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/app/usuarios',
    name: 'EnvivoUsuarios',
    component: () => import('../views/EnvivoUsuarios.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dev/usuarios',
    name: 'EnvivoDevUsuarios',
    component: () => import('../views/EnvivoDevUsuarios.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/app/backups',
    name: 'EnvivoBackups',
    component: () => import('../views/EnvivoBackups.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dev/backups',
    name: 'EnvivoDevBackups',
    component: () => import('../views/EnvivoDevBackups.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/game-settings',
    name: 'GameSettings',
    component: () => import('../views/GameSettings.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Guard de navegación
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
  const isAuthenticated = api.isAuthenticated()

  if (requiresAuth && !isAuthenticated) {
    // Ruta requiere autenticación pero no hay sesión
    next('/login')
  } else if (requiresGuest && isAuthenticated) {
    // Ruta es para invitados pero hay sesión activa
    next('/')
  } else if (requiresAuth && isAuthenticated) {
    // Verificar que la sesión sigue siendo válida
    try {
      await api.verify()
      next()
    } catch {
      // Sesión inválida
      next('/login')
    }
  } else {
    next()
  }
})

export default router
